import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../../../../api';
import { SnackbarContext } from '../../../../contexts';
import Handler from '../../../../Handler';

export const useSignUp = () => {
  const { updateSnackbar } = useContext(SnackbarContext);
  const { t } = useTranslation();

  const [signUpResult, setSignUpResult] = useState(null);

  const initialValues = {
    email: '',
    password: '',
    name: '',
    phone: '',
    companyName: '',
    ceoName: '',
    profileImage: '',
    businessNumber: '',
    businessFile: '',
    address: {
      addr1: '',
      addr2: '',
    },
    site: '',
    fax: '',
    kyc: {
      position: '',
      role: '',
      isRepOwns25: null,
      isRepOnly25: null,
      isOtherOwns25: null,
      ownerList: [
        {
          name: '',
          position: '',
        },
      ],
    },
  };

  const genPayload = (data, termsChecks) => {
    const address = {
      addr1: data?.address?.addr1,
      addr2: data?.address?.addr2,
    };
    return {
      email: data.email,
      password: data.password,
      name: data.name,
      phone: data.phone,
      companyName: data.companyName,
      ceoName: data.ceoName,
      businessNumber: data.businessNumber,
      businessFile: data.businessFile,
      address: JSON.stringify(address),
      site: data.site,
      fax: data.fax,
      kyc: {
        position: data.kyc.position,
        role: data.kyc.role,
        isRepOwns25: data.kyc.isRepOwns25,
        isRepOnly25: data.kyc.isRepOnly25,
        isOtherOwns25: data.kyc.isOtherOwns25,
        ...(data.kyc.ownerList || []).slice(0, 4).reduce((acc, owner, index) => {
          if (owner) {
            acc[`ownerName${index + 1}`] = owner.name || '';
            acc[`ownerPos${index + 1}`] = owner.position || '';
          }
          return acc;
        }, {}),
      },
      isMarketingAgree: termsChecks[3],
      profileImage: data?.profileImage || Handler.GET_DEFAULT_IMAGE('company'),
    };
  };

  const fileUpload = async (file, path) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', path);

    return API.Common.PostFile(formData).then((res) => {
      return res.data.cloudUrl;
    });
  };

  const postSignUp = async (data, termsChecks, onSuccess) => {
    const payload = genPayload(data, termsChecks);
    if (data.profileImage) {
      const profileImageUrl = await fileUpload(data.profileImage, 'signup/profile_image');
      payload.profileImage = profileImageUrl;
    }
    const businessFileUrl = await fileUpload(data.businessFile, 'signup/business_file');
    if (!businessFileUrl) {
      updateSnackbar({
        type: 'error',
        open: true,
        message: t('BIZ_FILE_UPLOAD_FAILED'),
      });
      return false;
    } else {
      payload.businessFile = businessFileUrl;
    }
    API.User.Signup(payload)
      .then((res) => {
        const result = res.data;
        setSignUpResult(result);
        if (onSuccess) {
          onSuccess(result);
        }
      })
      .catch((err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.fieldErrors ? err.data.fieldErrors[0].reason : err.data.message,
        });
        return false;
      });
  };

  return {
    signUpResult,
    postSignUp,
    initialValues,
  };
};
